function getThreeMonthsAgo(): Date {
  const now: Date = new Date();
  now.setMonth(now.getMonth() - 3);
  return now;
}

export default getThreeMonthsAgo;
